import mapboxgl from "mapbox-gl";
import fetch from "node-fetch";
import {
  EventBus
} from "../../data/EventBus";

import {
  Config
} from "../../data/Config/Config";
//import U from "mapbox-gl-utils";
import Requests from "../../data/RequestManager";

export default class MapSelection {
  constructor(_mapComponent) {
    this._mapComponent = _mapComponent;
    this.busySelecting = false;
  }

  async selectFromClick(e) {
    if (this.busySelecting) return;
    this.busySelecting = true;
    let features = await this._mapComponent.map.queryRenderedFeatures(e.point);

    let district = features.filter((d) =>
      d.layer.id.includes(this._mapComponent.districtType) &&
      !d.layer.id.includes('label') //Ignore labels if they're clicked on!
    );

    //if it doesn't find a district from the click, could be that a layer is covering it so look for it the same way it's searched from a url
    if (district.length < 1) {
      this.selectFromUrlMarker([e.lngLat.lng, e.lngLat.lat]);
      this.busySelecting = false;
      return;
    }

    this._mapComponent.selectedDistrictNew = district[0].properties.geoid;
    await this._mapComponent.districtDataRequest(
      this._mapComponent.selectedDistrictNew,
      this._mapComponent.districtType,
      this._mapComponent.tableSuffix,
      e
    );
    this._mapComponent.$store.commit("setLoading", false);
    this._mapComponent.$store.commit("setSelectedPoint", e);

    this.setHighlightGeoidFilter();

    if (this._mapComponent.marker) {
      this._mapComponent.marker = null;
    }

    this._mapComponent.marker = new mapboxgl.Marker()
      .setLngLat([e.lngLat.lng, e.lngLat.lat])
      .addTo(this._mapComponent.map);

    this.busySelecting = false;
  }


  async selectFromDistrictTypeSwitch(e, newDistrictType) {
    if (!e.lngLat || typeof e.lngLat === 'undefined') return;
    if (this.busySelecting) return;
    this.busySelecting = true;
    const newGeoidURL = Requests.getDistrictsFromLatLng(
      e.lngLat.lng,
      e.lngLat.lat,
      newDistrictType,
      this._mapComponent.tableSuffix
    );

    const new_response = await fetch(newGeoidURL);
    const district = await new_response.json();
    this._mapComponent.selectedDistrictNew = district[0].geoid;
    await this._mapComponent.districtDataRequest(
      this._mapComponent.selectedDistrictNew,
      newDistrictType,
      this._mapComponent.tableSuffix,
      e
    );
    this._mapComponent.$store.commit("setLoading", false);
    this._mapComponent.$store.commit("setSelectedPoint", e);
    this.busySelecting = false;
    this.setHighlightGeoidFilter();
  }

  async selectFromAddressLngLat(adrLngLat) {
    const newGeoidURL = Requests.getDistrictsFromLatLng(
      adrLngLat[0],
      adrLngLat[1],
      this._mapComponent.districtType,
      this._mapComponent.tableSuffix
    );

    const new_response = await fetch(newGeoidURL);
    const district = await new_response.json();
    this._mapComponent.selectedDistrictNew = district[0].geoid;

    let e = {
      lngLat: {
        lng: adrLngLat[0],
        lat: adrLngLat[1],
      },

    };

    await this._mapComponent.districtDataRequest(
      this._mapComponent.selectedDistrictNew,
      this._mapComponent.districtType,
      this._mapComponent.tableSuffix,
      e
    );
    this._mapComponent.$store.commit("setLoading", false);
    this._mapComponent.$store.commit("setSelectedPoint", e); //e needs to be something else here or can remove?

    this.setHighlightGeoidFilter();

    if (this._mapComponent.marker) {
      this._mapComponent.marker.remove()
      this._mapComponent.marker = null;
    }

    this._mapComponent.marker = new mapboxgl.Marker()
      .setLngLat([e.lngLat.lng, e.lngLat.lat])
      .addTo(this._mapComponent.map);

    this._mapComponent.zoomToSelected();
  }

  async selectFromUrlMarker(adrLngLat) {

    const newGeoidURL = Requests.getDistrictsFromLatLng(
      adrLngLat[0],
      adrLngLat[1],
      this._mapComponent.districtType,
      this._mapComponent.tableSuffix
    );

    const new_response = await fetch(newGeoidURL);
    const district = await new_response.json();
    if (district.length === 0) {
      EventBus.$emit("alert");
      this._mapComponent.$store.commit("setSelectedData", {});
      this._mapComponent.$store.commit("setLoading", false);

      EventBus.$emit("clear-data");

      return;
    }
    this._mapComponent.selectedDistrictNew = district[0].geoid;

    let e = {
      lngLat: {
        lng: adrLngLat[0],
        lat: adrLngLat[1],
      },

    };

    await this._mapComponent.districtDataRequest(
      this._mapComponent.selectedDistrictNew,
      this._mapComponent.districtType,
      this._mapComponent.tableSuffix,
      e
    );

    this._mapComponent.$store.commit("setLoading", false);
    this._mapComponent.$store.commit("setSelectedPoint", e); //e needs to be something else here or can remove?

    this.setHighlightGeoidFilter();

    if (this._mapComponent.marker) {
      this._mapComponent.marker.remove()
      this._mapComponent.marker = null;
    }

    this._mapComponent.marker = new mapboxgl.Marker()
      .setLngLat([e.lngLat.lng, e.lngLat.lat])
      .addTo(this._mapComponent.map);
  }

  async selectFromUrlGeoid(geoid) {

    this._mapComponent.selectedDistrictNew = geoid;

    await this._mapComponent.districtDataRequest(
      this._mapComponent.selectedDistrictNew,
      this._mapComponent.districtType,
      this._mapComponent.tableSuffix,

    );
    this._mapComponent.$store.commit("setLoading", false);

    this.setHighlightGeoidFilter();

    if (this._mapComponent.marker) {
      this._mapComponent.marker.remove()
      this._mapComponent.marker = null;
    }

  }

  async selectFromSearchGeoid(geoid) {
    if (this._mapComponent.marker) {
      this._mapComponent.marker.remove();
      this._mapComponent.marker = null;
      this._mapComponent.$store.commit("setMarkerLoc", "-1");
    }
    this.selectFromUrlGeoid(geoid);
    this._mapComponent.zoomToSelected();
  }

  setHighlightGeoidFilter() {
    let self = this;

    Config.layersConfig.choroplethLayerArray.forEach((layer) => {
      if (layer.id.includes('highlight')) {
        layer.filter = ["==", ["get", "geoid"], self._mapComponent.selectedDistrictNew.toString()];
        if (self._mapComponent.map.getLayer(layer.id)) {
          self._mapComponent.map.setFilter(layer.id, [
            "==",
            ["get", "geoid"],
            self._mapComponent.selectedDistrictNew.toString(),
          ]);
        } else {
          self._mapComponent.map.once('idle', () => {
            self._mapComponent.map.setFilter(layer.id, [
              "==",
              ["get", "geoid"],
              self._mapComponent.selectedDistrictNew.toString(),
            ]);
          });
        }

      }

    });
  }

}